<app-body>

    <div class="page-container fullheight" style="background: #242732;">
        <div class="flex-container margin-bottom-1">
            <div class="flex-item flex-1">
                <h1>Catalog</h1>
            </div>

        </div>

        <app-tab-menu [tab_menu_list]="tab_menu_list"></app-tab-menu>


        <app-table-action >
            <button *ngIf="tab_view == 'product'" (click)="this.showModal = true" class="button small">
                Add Product
            </button>
            <button *ngIf="tab_view == 'category'" (click)="this.showCategory = true" class="button small">
                Add Category
            </button>
        </app-table-action>

        <div *ngIf="tab_view =='product'">
            <div *ngFor="let item of products"
                class="callout border radius rounded padding-center-1 flex-container margin-bottom-05">
                <div class="flex-item margin-right-1">
                    <img width="75" height="75" [src]="item.product_cover" alt="">
                    <input class="hide" type="file" (change)="onChange($event,item)" #fileUpload />
                    <div> <button (click)="fileUpload.click()" class="button tiny clear active"
                            style="margin-right: 2px;">
                            Upload
                        </button></div>
                </div>
                <div class="flex-item flex-15">
                    <div class="large-text">
                        <!-- {{item.name}} -->
                        <app-form-input (onClose)="updateField($event,item.id)" isHideLabel="true" isHideAction="true"
                            [value]="item.name" [id]="'name'"></app-form-input>
                        <!-- {{item.long_description}} -->
                    </div>
                    <!-- <div class="large-text">
                    {{item.name}}
                </div> -->
                </div>

                <!-- <div class="flex-item flex-1 margin-right-1">

                <app-form-select [selected_option]="item.category_name" (onSelect)="updateCat($event,item.id)"
                    [option]="cat"></app-form-select>

            </div> -->
                <div class="flex-item flex-1">
                    <div class="small-text color-grey">
                        Price
                    </div>
                    <div class="large-text">
                        <!-- {{item.price}} -->
                        <app-form-input (onClose)="updateField($event,item.id)" isHideLabel="true" isHideAction="true"
                            [value]="item.price" [type]="'currency'" [id]="'price'"></app-form-input>
                    </div>


                </div>
                <div class="flex-item flex-1">
                    <div class="small-text color-grey">
                        Special Price
                    </div>
                    <div class="large-text">
                        <!-- {{item.special_price}} -->
                        <app-form-input (onClose)="updateField($event,item.id)" isHideLabel="true" isHideAction="true"
                            [value]="item.special_price" [type]="'currency'" [id]="'special_price'"></app-form-input>

                    </div>


                </div>
                <div class="flex-item flex-1 text-right">
                    <button (click)="selected_product = item" class="button tiny clear active hollow margin-right-05">
                        View
                    </button>
                    <label class="switch">
                        <input type="checkbox" [checked]="item.status"
                            (change)="updateStatus(item,$event.target.checked)">
                        <span class="slider round"></span>
                    </label>
                </div>
            </div>

        </div>

        <div *ngIf="tab_view =='category'">
            <ng-container *ngFor="let type of ['BRAND','CATEGORY', 'ACTIVITY','CAMPAIGN']">
                
            </ng-container>
            
            <div *ngFor="let item of category"
                class="callout border radius rounded padding-center-1 flex-container margin-bottom-05">
                <!-- <div> 
                    <img width="100" height="100" [src]="item.feature_image" alt="">

                    <input class="hide" type="file" (change)="onChangeCat($event,item)" #fileUpload />
                    
                    <button (click)="fileUpload.click()" class="button tiny clear active"
                    style="margin-right: 2px;">
                    Upload
                </button></div> -->
                <div *ngIf="item.parrent?.name" class="flex-item margin-right-05">
                    {{item.parrent?.name}} /
                </div>
                <div class="flex-item flex-15">
                    
                    <div class="large-text">
                      
                        <app-form-input (onClose)="updateCategoryField($event,item.id)" isHideLabel="true" isHideAction="true"
                            [value]="item.name" [id]="'name'"></app-form-input>
                        <!-- {{item.long_description}} -->
                    </div>
                  
                </div>

             
                
                <div class="flex-item flex-1 text-right">
                    <button (click)="selectCategoryProduct(item)" class="button tiny clear active hollow margin-right-05">
                      View / Add Product
                    </button>
                    <label class="switch">
                        <input type="checkbox" [checked]="item.status"
                            (change)="updateCategoryStatus(item,$event.target.checked)">
                        <span class="slider round"></span>
                    </label>
                </div>
            </div>

        </div>

    </div>

  

</app-body>

<app-modal-full *ngIf="showModal == true" title="Add Product">
    <form class="form" [formGroup]="productForm">
        <div class="margin-bottom-1 padding-bottom-1 white ">

            <!-- <div class="name">Category</div> -->
            <!-- <select [(value)]="selectedData" (change)="selectCategory()">
                <option *ngFor="let item of cat" [value]="item">{{item.name}}</option>
            </select> -->


            <!-- <app-form-select [label]="'Category'" (onSelect)="selectCategory($event)" [option]="cat">
            </app-form-select> -->

            <div class="name">Name</div>
            <input type="text" formControlName="name">

            <div class="name">Description</div>
            <input type="text" formControlName="long_description">

            <div class="name">Price</div>
            <input type="number" formControlName="price">

            <div class="name">Special Price</div>
            <input type="number" formControlName="special_price">

        </div>
        <button [disabled]="!this.productForm.valid" class="button expanded " (click)="addProduct()">
            Product
        </button>



    </form>
</app-modal-full>

<app-modal-full *ngIf="showCategory == true" title="Add Category">
    <form class="form" [formGroup]="categoryForm">
        <div class="margin-bottom-1 padding-bottom-1 white ">

          



            <div class="name">Name</div>
            <input type="text" formControlName="name">

            <app-form-select [label]="'Parrent Category'" (onSelect)="selectParrentCategory($event)" [option]="cat">
            </app-form-select>


        </div>
        <button [disabled]="!this.categoryForm.valid" class="button expanded " (click)="addCategory()">
            Add Category
        </button>



    </form>
</app-modal-full>

<app-modal-full (onClose)="selected_product = null" [title]="selected_product.name" *ngIf="selected_product">
    <div class="list-tile-container">
      

        <div class="list-tile-item">
            <app-form-input (onClose)="updateField($event,selected_product.id)" [label]="'name'" isHideAction="true"
                [value]="selected_product.name" [id]="'name'"></app-form-input>

        </div>

        <div class="list-tile-item">
            <app-form-input (onClose)="updateField($event,selected_product.id)" [label]="'Price'" [type]="'currency'"
                isHideAction="true" [value]="selected_product.price" [id]="'price'"></app-form-input>

        </div>
        <div class="list-tile-item">
            <app-form-input (onClose)="updateField($event,selected_product.id)" [label]="'Special Price'"
                isHideAction="true" [value]="selected_product.special_price" [type]="'currency'" [id]="'special_price'">
            </app-form-input>

        </div>
        <div class="list-tile-item">
            <app-form-input (onClose)="updateField($event,selected_product.id)" [label]="'Description'"
                isHideAction="true" [value]="selected_product.long_description" [id]="'long_description'">
            </app-form-input>

        </div>
    </div>

</app-modal-full>

<app-modal-full (onClose)="selected_category = null" [title]="selected_category.name" *ngIf="selected_category">
    <div class="margin-bottom-1">
        <app-form-search (onSearch)="searchProduct($event)"></app-form-search>
    </div>
    <div *ngFor="let item of products"
                class="callout border radius rounded padding-center-1 flex-container margin-bottom-05">
                <div class="flex-item margin-right-1">
                    <img width="50" height="50" [src]="item.product_cover" alt="">
                 
                </div>

                <div class="flex-item margin-right-1">
                  {{item.name}}
                </div>
               
                <div class="flex-item flex-1 text-right">
                    <button *ngIf="!is_search" (click)="removeCategoryProduct(item)" class="button tiny clear active hollow margin-right-05">
                        Remove
                    </button>
                    <button *ngIf="is_search" (click)="addCategoryProduct(item)" class="button tiny clear active hollow margin-right-05">
                        Add Product
                    </button>
                  
                </div>
            </div>

</app-modal-full>